import React, { useMemo } from 'react'
import { ReactComponent as AddIcon } from '../add.svg'

const withAddIcon = Component => ({ onAddRecord, columns, ...props }) => {
	const lastColIndex = columns.reduce((ind, { show }, i) => {
		if(show !== false) {
			return i
		}
		return ind
	}, columns.length - 1)

	const oldHeader = columns[lastColIndex].Header
	const newColumns = columns.map(col => ({ ...col }))
	const lastColumnHeader = useMemo(() => {
		return (...args) => {
			return(
				<>
					<span className='sort-icons'>{typeof oldHeader === 'function' ? oldHeader(...args) : oldHeader}</span>
					<AddIcon className={'add-icon'} onClick={e => {
						e.stopPropagation()
						onAddRecord(e)
					}}/>
				</>
			)
		}
	}, [oldHeader]) // eslint-disable-line


	newColumns[lastColIndex] = {
		...newColumns[lastColIndex],
		Header: lastColumnHeader,
		headerStyle: { borderRight: 'none' },
		width: 80
	}

	return (
		<Component
			{...props}
			columns={newColumns}
		/>
	)
}

export default withAddIcon
